import React, { useState } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import UserForm from './UserForm';

const UserModal = ({ 
  show, 
  onHide, 
  user = null, 
  onSave, 
  title 
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (formData) => {
    try {
      setIsLoading(true);
      setError('');
      await onSave(formData);
      onHide(); // Close modal on success
    } catch (err) {
      console.error('Error saving user:', err);
      const errorMsg = err.response?.data?.error || 'Failed to save user';
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || (user ? 'Edit User' : 'Add New User')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        <UserForm
          user={user}
          onSubmit={handleSubmit}
          onCancel={handleClose}
          isLoading={isLoading}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserModal;
